<template>
	<b-modal id="modal_active_page_2" class="bg-color-light" size="md" scrollable centered hide-header hide-footer @hidden="handleCloseModal">
		<div class="active-code border-rd-8 bg-color-light position-rel">
			<!-- <div class="spinner-box" v-if="loading">
				<div class="spinner-box__wrap display-flex-center justify-content-center full-box">
					<b-spinner class="" variant="primary" label="Text Centered"></b-spinner>
				</div>
			</div> -->
			<div class="active-code__wrap">
				<h3 class="active-code__title font-size-24 font-sanpro-semibold primary-color-txt">Kích hoạt sách</h3>
				<div class="active-code__desc active-code__desc--experience primary-color-txt font-sanpro-light">
					<p v-if="nameRouter === 'ebook-read-book'" class="margin-0">Bạn đã xem đến giới hạn tối đa của sách điện tử.</p>
					<p v-if="nameRouter === 'exerciseDetail'" class="margin-0">Bạn đã xem hết số bài hiện có. Các bài tập sẽ được cập nhật thêm trong thời gian tới.</p>

					<!-- <p>Vui lòng liên hệ admin để biết thêm chi tiết.</p> -->
				</div>
			</div>
		</div>
	</b-modal>
    
</template>

<script>
	import { mapState, mapActions } from 'vuex';

    export default {
		name: 'ActiveBook2',
		computed: {
			...mapState('common', ['isShowModalActiveBookPage']),
		},
        data() {
            return {
                // loading: false
				nameRouter: this.$route.name
            }
		},
		watch: {
			isShowModalActiveBookPage(newVal) {
				if(newVal) {
					this.$bvModal.show('modal_active_page_2')
				} else {
					this.$bvModal.hide('modal_active_page_2');
				}
			}
		},
		mounted(){
		},
		methods: {
			...mapActions('common', ['setToggleModalActivePage']),

			handleCloseModal() {
				this.setToggleModalActivePage(false);
			}
		}
    }
</script>

<style lang="scss" scoped>
	#modal_active_page_2 {
		.modal-content {
			border: 0;
		}
		.modal-content, .modal-body {
			border-radius: 15px;
		}

		.modal-body {
			background: #fff;
			padding: 20px 25px;
		}

		.active-code {
			&__wrap {
				padding: 18px 16px;
			}

			&__title, &__desc {
				margin-bottom: 15px;
			}
		}
	}
</style>